"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../../../../utils/constants");
var _utils = require("../../../../utils/utils");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BaseQuestion = /*#__PURE__*/function () {
  function BaseQuestion(_ref) {
    var _this = this;
    var question = _ref.question,
      selections = _ref.selections,
      metadata = _ref.metadata;
    _classCallCheck(this, BaseQuestion);
    this.question = {};
    this.selections = [];
    this.metadata = {};
    this.metadataModifiers = {
      weights: {},
      filters: {},
      ranges: {},
      targetPoints: {},
      targetValues: {},
      targetStringValues: {}
    };
    this.getMinRange = function (minValue) {
      var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        min: 0,
        max: _constants.UNLIMITED_VALUE
      };
      var isCumulative = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var min = isCumulative ? range.min + minValue : Math.max(range.min, minValue);
      return {
        min: min,
        max: range.max
      };
    };
    this.getMaxRange = function (maxValue) {
      var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        min: 0,
        max: _constants.UNLIMITED_VALUE
      };
      var isCumulative = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var max = isCumulative ? range.max - maxValue : Math.min(range.max, maxValue);
      return {
        min: range.min,
        max: max
      };
    };
    this.checkCategory = function (category) {
      if (!_this.metadata[category]) {
        _this.metadata[category] = (0, _utils.clone)(_this.metadataModifiers);
      }
    };
    this.question = question;
    this.selections = selections;
    this.metadata = metadata;
  }
  _createClass(BaseQuestion, [{
    key: "updateMetaData",
    value: function updateMetaData() {
      return this.handleCharacteristics(this.question.characteristics);
    }
  }, {
    key: "handleCharacteristics",
    value: function handleCharacteristics() {
      var _this2 = this;
      var characteristics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      characteristics.forEach(function (characteristic) {
        var _characteristic$categ;
        (_characteristic$categ = characteristic.category) === null || _characteristic$categ === void 0 ? void 0 : _characteristic$categ.forEach(function (category) {
          _this2.handleMinRange(characteristic, category);
          _this2.handleMaxRange(characteristic, category);
          _this2.handleFilters(characteristic, category);
          _this2.handleWeights(characteristic, category);
          _this2.handleTargetPoints(characteristic, category);
          _this2.handleTargetValues(characteristic, category);
          _this2.handleTargetStringValues(characteristic, category);
        });
      });
      return this.metadata;
    }
  }, {
    key: "getCharacteristicName",
    value: function getCharacteristicName(characteristic) {
      return characteristic.name || this.question.characteristicName;
    }
  }, {
    key: "getConversionFactor",
    value: function getConversionFactor() {
      return this.question.conversionFactor || 1;
    }
  }, {
    key: "getIsCumulative",
    value: function getIsCumulative() {
      return this.question.isCumulative;
    }
  }, {
    key: "getValue",
    value: function getValue(value) {
      var conversionFactor = this.getConversionFactor();
      value = value.toString().replace('{{value}}', this.selections[0]);
      return parseFloat(value) * conversionFactor;
    }
  }, {
    key: "handleFlags",
    value: function handleFlags(enable) {
      var _this3 = this;
      if (!enable) {
        return;
      }
      if (!this.metadata.flags) {
        this.metadata.flags = {};
      }
      enable.forEach(function (enableFlag) {
        return _this3.metadata.flags[enableFlag] = true;
      });
    }
  }, {
    key: "handleFilters",
    value: function handleFilters(characteristic, category) {
      var _this4 = this,
        _this$metadata$catego;
      if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.filter) === undefined) {
        return;
      }
      var filter = characteristic.filter.map(function (filterItem) {
        return filterItem.replace('{{value}}', _this4.selections[0]);
      });
      var characteristicName = this.getCharacteristicName(characteristic);
      this.checkCategory(category);
      if (!this.metadata[category].filters[characteristicName]) {
        this.metadata[category].filters[characteristicName] = [];
      }
      (_this$metadata$catego = this.metadata[category].filters[characteristicName]).push.apply(_this$metadata$catego, _toConsumableArray(filter));
    }
  }, {
    key: "handleMinRange",
    value: function handleMinRange(characteristic, category) {
      if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.min) === undefined) {
        return;
      }
      var characteristicName = this.getCharacteristicName(characteristic);
      var isCumulative = this.getIsCumulative();
      var value = this.getValue(characteristic.min);
      this.checkCategory(category);
      var currentRange = this.metadata[category].ranges[characteristicName];
      this.metadata[category].ranges[characteristicName] = this.getMinRange(value, currentRange, isCumulative);
    }
  }, {
    key: "handleMaxRange",
    value: function handleMaxRange(characteristic, category) {
      if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.max) === undefined) {
        return;
      }
      var characteristicName = this.getCharacteristicName(characteristic);
      var isCumulative = this.getIsCumulative();
      var value = this.getValue(characteristic.max);
      this.checkCategory(category);
      var currentRange = this.metadata[category].ranges[characteristicName];
      this.metadata[category].ranges[characteristicName] = this.getMaxRange(value, currentRange, isCumulative);
    }
  }, {
    key: "handleWeights",
    value: function handleWeights(characteristic, category) {
      if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.weight) === undefined) {
        return;
      }
      var characteristicName = this.getCharacteristicName(characteristic);
      this.checkCategory(category);
      this.metadata[category].weights[characteristicName] = this.getValue(characteristic.weight);
    }
  }, {
    key: "handleTargetPoints",
    value: function handleTargetPoints(characteristic, category) {
      if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.targetPoint) === undefined) {
        return;
      }
      var characteristicName = this.getCharacteristicName(characteristic);
      this.checkCategory(category);
      this.metadata[category].targetPoints[characteristicName] = this.getValue(characteristic.targetPoint);
    }
  }, {
    key: "handleTargetValues",
    value: function handleTargetValues(characteristic, category) {
      if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.targetValue) === undefined) {
        return;
      }
      var characteristicName = this.getCharacteristicName(characteristic);
      this.checkCategory(category);
      this.metadata[category].targetValues[characteristicName] = this.getValue(characteristic.targetValue);
    }
  }, {
    key: "handleTargetStringValues",
    value: function handleTargetStringValues(characteristic, category) {
      var _this$metadata$catego2;
      if ((characteristic === null || characteristic === void 0 ? void 0 : characteristic.targetStringValue) === undefined) {
        return;
      }
      var characteristicName = this.getCharacteristicName(characteristic);
      this.checkCategory(category);
      if (!this.metadata[category].targetStringValues[characteristicName]) {
        this.metadata[category].targetStringValues[characteristicName] = [];
      }
      (_this$metadata$catego2 = this.metadata[category].targetStringValues[characteristicName]).push.apply(_this$metadata$catego2, _toConsumableArray(characteristic.targetStringValue));
    }
  }]);
  return BaseQuestion;
}();
exports.default = BaseQuestion;